<template>
  <div class="home">
    <div class="banner-container">
      <swiper v-if="swiperIsShow" ref="HomeSwiper" :options="swiperOption">
        <swiper-slide v-for="(slide, index) in banner(0)" :key="index">
          <img :src="slide.carousel_image | imgFilter"/>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <!-- 集团简介 -->
    <vue-lazy-component>
      <Introduction></Introduction>
      <skeleton slot="skeleton"></skeleton>
    </vue-lazy-component>
    <!-- 产品服务 -->
    <vue-lazy-component>
      <service></service>
      <skeleton slot="skeleton"></skeleton>
    </vue-lazy-component>

    <!-- 客户案例 -->
    <vue-lazy-component>
      <customer-case></customer-case>
      <skeleton slot="skeleton"></skeleton>
    </vue-lazy-component>
  </div>
</template>

<script>
import customerCase from "./components/customerCase.vue";
import Introduction from "./components/Introduction.vue";
import service from "./components/service.vue";
import { getIndexCarousel, getImgs } from "@/api";
import { mapActions, mapGetters } from "vuex";
import skeleton from "@/components/skeleton";
export default {
  name: "home",
  data() {
    return {
      swiperIsShow: true,
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          autoplay: true,
          delay: 5000
        },
        loop: true
      },
      videoSrc:require('@/assets/video/4kvideo.mp4'),
      gifSrc:require('@/assets/video/4kgif.gif')
    };
  },
  computed: {
    ...mapGetters("banner", ["banner"]),
    banners() {
      return this.banner(0);
    }
  },
  watch: {
    banners() {
      this.initSwiper();
    }
  },
  methods: {
    ...mapActions("banner", ["getBanner"]),
    initSwiper() {
      // 在banner数据改变时需要重新初始化swiper
      this.swiperIsShow = false;
      this.$nextTick(() => (this.swiperIsShow = true));
    }
  },
  components: {
    customerCase,
    Introduction,
    service,
    skeleton
  },
  created() {
    if (!this.banner(0).length) this.getBanner(0);
  },
  mounted() {
    this.initSwiper();
  }
};
</script>
<style lang="scss" scoped>
@import url("~@/assets/css/common.scss");
.home {
  width: 100%;
  // height:
  .banner-container {
    width: 100%;
    position: relative;
    ::v-deep .swiper-pagination-bullet {
      background-color: #fff;
      width: 40px;
      border-radius: 0;
      height: 4px;
    }

    img {
      width: 100%;
      vertical-align: top;
    }
  }
  ::v-deep .title-container {
    display: inline-block;
    position: relative;
    vertical-align: top;
    margin-bottom: 61px;
    font-size: 26px;
    &::before {
      content: "";
      position: absolute;
      z-index: 0;
      box-sizing: border-box;
      border: 4px solid #ccc;
      left: 72px;
      top: -11px;
      bottom: -12px;
      opacity: 0.2;
      right: -120px;
    }
    .main-title {
      color: #30659b;
      margin-bottom: 17px;
      position: relative;
      z-index: 1;
    }
    .sub-title {
      color: #333;
      z-index: 1;
      position: relative;
    }
  }
}
</style>
